import { axiosEduServer } from "../utils/configAxios";

export const crearIdioma = (data) => {
  return axiosEduServer.post('/idioma', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarIdioma = (id, data) => {
  return axiosEduServer.put(`/idioma/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarIdioma = (id) => {
  return axiosEduServer.delete(`/idioma/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneIdioma = (id) => {
  return axiosEduServer.get(`/idioma/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllIdiomas = () => {
  return axiosEduServer.get('/idioma').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllIdiomasByIdNivel = (idNivel) => {
  return axiosEduServer.get(`/idioma/idnivel/${idNivel}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllIdiomasByIdDocente = (idDocente) => {
  return axiosEduServer.get(`/idioma/iddocente/${idDocente}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllIdiomasByIdEstudiante = (idEstudiante) => {
  return axiosEduServer.get(`/idioma/idestudiante/${idEstudiante}`).then(({ data }) => data).catch((err) => { throw err });
};